import { ApplicationRef } from '@angular/core';
import { Component, Input } from '@angular/core';
import { ToastNoAnimation, ToastPackage, ToastrService } from 'ngx-toastr';

@Component({
  selector: '[action-toast-component]',
  templateUrl: './action-toast.component.html',
  styleUrls: ['./action-toast.component.scss'],
  host: {
    '[class.toast-state-active]': 'state() === "active"',
    '[class.toast-state-removed]': 'state() === "removed"'
  },
  preserveWhitespaces: false,
  standalone: false
})
export class ActionToastComponent extends ToastNoAnimation {
  @Input() buttonText: string = null;

  constructor(
    protected override toastrService: ToastrService,
    public override toastPackage: ToastPackage,
    appRef: ApplicationRef
  ) {
    super(toastrService, toastPackage, appRef);
  }

  override remove(): void {
    if (this.state() === 'removed') {
      return;
    }
    this.state.set('removed');
    const easeTime = +this.toastPackage.config.easeTime || 400;
    setTimeout(
      () => this.toastrService.remove(this.toastPackage.toastId),
      easeTime
    );
  }

  action(event: Event): boolean {
    event.stopPropagation();
    this.toastPackage.triggerAction();
    this.toastrService.clear();
    return false;
  }
}
